import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.1667 17.0834H5.83334C3.33334 17.0834 1.66667 15.8334 1.66667 12.9167V7.08341C1.66667 4.16675 3.33334 2.91675 5.83334 2.91675H14.1667C16.6667 2.91675 18.3333 4.16675 18.3333 7.08341V12.9167C18.3333 15.8334 16.6667 17.0834 14.1667 17.0834Z",
		stroke: "black",
		strokeOpacity: .6,
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.1667 7.5L11.5583 9.58333C10.7 10.2667 9.29167 10.2667 8.43334 9.58333L5.83334 7.5",
		stroke: "black",
		strokeOpacity: .6,
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEmail;
